const oiFilterForm = document.getElementById('oi-filter-form');
let filterBatchLoader = null;
let currentFilterController = null;

function update_url(resp) {
    if (window.history && "pushState" in window.history) {
        const url = resp.data.data.url;
        window.history.pushState(null, "", url);
        const canonical = document.querySelector('link[rel="canonical"]');
        if (canonical !== null) {
            canonical.href = url;
        }
    }
}
function groupBy(objectArray, property, value) {
    return objectArray.reduce(function (acc, obj) {
        const key = obj[property];
        if (!acc[key]) {
            acc[key] = [];
        }
        acc[key].push(obj[value]);
        return acc;
    }, {});
}
function getFormData(filter_form) {
    let formData = new FormData(filter_form);
    let object = [];
    formData.forEach(function (value, key) {
        const o = {
            name: key,
            value: value,
        };
        object.push(o);
    });
    const pieces = groupBy(object, "name", "value");
    formData = new FormData();
    for (const piece in pieces) {
        if (pieces.hasOwnProperty(piece)) {
            formData.append(piece, pieces[piece].join("|"));
        }
    }
    return formData;
}
function oiFilterDisableForm(oi_filter_form) {
    if (oi_filter_form) {
        let i;
        for (i = 0; i < oi_filter_form.elements.length; i++) {
            oi_filter_form.elements[i].setAttribute("disabled", "disabled");
        }
        const to_disable = document.getElementsByClassName(
            "oi-disable-while-pending"
        );
        for (i = 0; i < to_disable.length; i++) {
            to_disable[i].setAttribute("disabled", "disabled");
        }
        const model_filters = document.getElementsByClassName("model-filters");
        for (i = 0; i < model_filters.length; i++) {
            model_filters[i].style.opacity = "0.6";
        }
    }
}
function oiFilterEnableForm(oi_filter_form) {
    if (oi_filter_form) {
        setTimeout(function () {
            let i;
            for (i = 0; i < oi_filter_form.elements.length; i++) {
                if (oi_filter_form.elements[i].closest(".is-locked")) continue;
                oi_filter_form.elements[i].disabled = false;
                oi_filter_form.elements[i].removeAttribute("disabled");
            }
            const to_disable = document.getElementsByClassName(
                "oi-disable-while-pending"
            );
            for (i = 0; i < to_disable.length; i++) {
                to_disable[i].disabled = false;
                to_disable[i].removeAttribute("disabled");
            }
            const model_filters =
                document.getElementsByClassName("model-filters");
            for (i = 0; i < model_filters.length; i++) {
                model_filters[i].style.opacity = "1";
            }
        }, 500);
    }
}
function oiFilterAjaxBeforesend(oi_filter_form, from_infinite) {
    if (from_infinite === undefined || from_infinite === false) {
        oiFilterDisableForm(oi_filter_form);
    }
}

function oiFilterGetResults(oi_filter_form, results) {
    batchLoader.forEach(b => b.abort());
    filterBatchLoader?.abort();
    if (currentFilterController) {
        currentFilterController.abort();
    }
    currentFilterController = new AbortController();
    const filterController = currentFilterController;
    beforeAjaxCompletion(oi_filter_form, results);
    const ftype = oi_filter_form.dataset.filterType;
    const url = `/xhr/filter/${ftype}/`;
    const formData = getFormData(oi_filter_form);
    oi.axios({
        method: "post",
        url: url,
        data: formData,
        headers: {
            "Content-Type": "application/json",
        },
        signal: filterController.signal,
        transformRequest: [
            function (data, headers) {
                oiFilterAjaxBeforesend(oi_filter_form, false);
                return data;
            },
        ],
    })
        .then(function (resp) {
            afterAjaxCompletion(results);
            if (resp.data.data.result_list) {
                if (resp.data.data.options) {
                    const options = resp.data.data.options;
                    for (const id in options) {
                        const el = document.getElementById(id);
                        if (el) el.innerHTML = options[id];
                    }
                }
                if (resp.data.paginator && resp.data.paginator !== "") {
                    const pageinput =
                        oi_filter_form.querySelector('input[name="page"]');
                    pageinput.value = resp.data.paginator.next;
                }
                results.innerHTML = resp.data.data.result_list;
                const oi_filter_amount = document.getElementById("oi-filter-amount");
                if (oi_filter_amount !== null) {
                    oi_filter_amount.innerHTML = resp.data.data.amount || 0
                }
                if (resp.data.result_list_lot) {
                    const results_lot = document.getElementById(
                        "oi-filter-results-lot"
                    );
                    results_lot.innerHTML = resp.data.result_list;
                }
                if (resp.data.result_list_land) {
                    const results_land = document.getElementById(
                        "oi-filter-results-land"
                    );
                    results_land.innerHTML = resp.data.result_list;
                }
                if (resp.data.map_items && resp.data.map_items !== "") {
                    const map_items =
                        document.querySelector(".oi-all-map-items");
                    map_items.innerHTML = resp.data.map_items;
                }
                update_url(resp);
                if (window.afterResultsSuccess !== undefined) {
                    window.afterResultsSuccess();
                }
                const oiMap = oi.loaded.map && oi.loaded.map['oi-map'];
                if (oiMap) {
                    oiMap.set_markers(ftype);
                    oiMap.fit();
                }
                const ftype_remaining = resp.data.data.ftype_remaining || [];
                filterBatchLoader = new oi.filter.LoadedBatch({
                    form: oi_filter_form.id || oi_filter_form.dataset.resultsTarget,
                    items: ftype_remaining,
                    filterType: ftype,
                    beforeLoad: () => onBeforeLoad(),
                    afterLoad: () => onAfterLoad(),
                    beforeBatchLoad: () => onBeforeBatchLoad(),
                    afterBatchLoad: (response) => onAfterBatchLoad(response, results),
                });
                if (!ftype_remaining.length) {
                    clearLoadState();
                }
            } else {
                clearLoadState();
            }
        })
        .catch(function (error) {
            if (error.code === "ERR_CANCELED" || error.name === "AbortError") {
                return;
            }
            afterAjaxCompletion(results);
            if (error.response) {
                if (error.response.status == 400) {
                    let msg = "";
                    const errors = error.response.data.errors;
                    for (let err in errors) {
                        let x = errors[err];
                        msg = `${x.code} - ${x.description}\n`;
                    }
                    oiFilterEnableForm(oi_filter_form);
                } else if (error.response.status == 302) {
                    window.location.href = error.response.data.data.redirect;
                }
            } else if (error.request) {
                console.error(error.request);
            } else {
                console.error(error.message);
            }
        })
        .then(function () {
            if (filterController === currentFilterController) {
                const name_input = oi_filter_form.querySelector('input[name="m"]');
                if (name_input !== null) {
                    name_input.value = "0";
                }
                currentFilterController = null;
                oiFilterEnableForm(oi_filter_form);
            }
        });
}
window.addEventListener("load", () => {
    const oi_filter_form = document.getElementById("oi-filter-form");
    if (oi_filter_form) {
        const oi_filter_clickables =
            oi_filter_form.querySelectorAll(".oi-filter-click");
        const oi_filter_changables =
            oi_filter_form.querySelectorAll(".oi-filter-change");
        oi_filter_clickables.forEach((elem) => {
            elem.addEventListener("click", (e) => {
                e.preventDefault();
                oiFilterGetResults(oi_filter_form, oi_filter_results);
            });
        });
        oi_filter_changables.forEach((elem) => {
            elem.addEventListener("change", (e) => {
                e.preventDefault();
                oiFilterGetResults(oi_filter_form, oi_filter_results);
            });
        });
        const oi_filter_reset = oi_filter_form.querySelectorAll(".oi-filter-reset");
        const oi_filter_results = document.getElementById("oi-filter-results");
        if (oi_filter_reset !== null && oi_filter_results !== null) {
            oi_filter_reset.forEach((btn) => {
                btn.addEventListener("click", (e) => {
                    let i;
                    e.preventDefault();
                    const to_clear =
                        document.getElementsByClassName("oi-clear-on-reset");
                    if (to_clear) {
                        for (i = 0; i < to_clear.length; i++) {
                            if (to_clear[i].type == "select-one") {
                                to_clear[i].selectedIndex = 0;
                            }
                            if (to_clear[i].id == "boyl-input") {
                                to_clear[i].value = false;
                            }
                            if (to_clear[i].type == "checkbox") {
                                to_clear[i].checked = false;
                            }
                        }
                    }
                    const buttons_to_reset =
                        document.getElementsByClassName("filter-button-on");
                    if (buttons_to_reset) {
                        for (i = 0; i < buttons_to_reset.length; i++) {
                            buttons_to_reset[i].classList.remove(
                                "filter-button-on"
                            );
                        }
                    }
                    oiFilterGetResults(oi_filter_form, oi_filter_results);
                });
            });
        }
    }
    let pathName = document.location.pathname;
    window.addEventListener("popstate", (e) => {
        if (pathName === e.target.location.pathname) {
            return false;
        }
        location.reload();
    });

});


// --- Batch Loading ---

function addLoadingMessage() {
}

function removeLoadingMessage() {
}

function setFilterLoading(resultsContainer, loading) {
    const wrap = (resultsContainer && resultsContainer.closest(".lp-results-wrap")) || document.querySelector(".lp-results-wrap");
    if (wrap) wrap.classList.toggle("is-loading", loading);
    const loader = document.querySelector("[data-lp-loader]");
    if (loader) loader.hidden = !loading;
}

function beforeAjaxCompletion(filterForm, resultsContainer) {
    setFilterLoading(resultsContainer, true);
}

function afterAjaxCompletion(resultsContainer) {
    setFilterLoading(resultsContainer, false);
}

function onBeforeLoad() {
    addLoadingMessage();
}

function dispatchItemsLoaded() {
    const itemsLoaded = new CustomEvent('oiItemsLoaded', { detail: { message: 'items loaded' } });
    document.dispatchEvent(itemsLoaded);
}

function clearLoadState() {
    removeLoadingMessage();
    dispatchItemsLoaded();
}

function onAfterLoad() {
    clearLoadState();
}

function onBeforeBatchLoad() {
}

function onAfterBatchLoad(response, resultsContainer) {
    if (!resultsContainer) return;
    const html = response.data.data.result_list;
    const grid = resultsContainer.querySelector('.plan-grid');
    if (grid) {
        // Batches arrive wrapped in their own grid. Merging the columns keeps
        // one grid, so the rail stays a single run of cards and listpage.js
        // still finds every column under the first .plan-grid.
        const parsed = document.createRange().createContextualFragment(html);
        const cols = parsed.querySelectorAll('.plan-col');
        if (cols.length) {
            cols.forEach((col) => grid.appendChild(col));
            document.dispatchEvent(new Event('lp:content'));
        }
        return;
    }
    resultsContainer.insertAdjacentHTML('beforeend', html);
    document.dispatchEvent(new Event('lp:content'));
}

const batchLoader = [];

window.addEventListener('load', () => {
    document.querySelectorAll('.oi-filter-form').forEach((form) => {
        const items = JSON.parse(form.dataset.remainingItems || '[]');
        if (!items.length) {
            clearLoadState();
            return;
        }
        const resultsContainer = document.querySelector(form.dataset.resultsTarget || '#oi-filter-results');
        const loader = new oi.filter.LoadedBatch({
            items,
            form: form.id || form.dataset.resultsTarget,
            filterType: form.dataset.filterType || '',
            beforeLoad: () => onBeforeLoad(),
            afterLoad: () => onAfterLoad(),
            beforeBatchLoad: () => onBeforeBatchLoad(),
            afterBatchLoad: (response) => onAfterBatchLoad(response, resultsContainer),
        });
        batchLoader.push(loader);
    });
});
